/**
 * Bulk Mark as Done background job notice (via useBulkRmaActionNotice) and dismiss confirmation modal.
 */
import { observer } from "mobx-react";
import BackgroundJobNotices from "../background-job-notice/background-job-notices";
import RmaListBulkDismissModal from "../rma-list-bulk-dismiss-modal/rma-list-bulk-dismiss-modal";
import { useBulkRmaActionNotice } from "./use-bulk-rma-action-notice";

const RmaListBulkActionNotice: React.FC = observer(() => {
    const dismissModal = useBulkRmaActionNotice();

    return (
        <>
            <BackgroundJobNotices />
            {dismissModal && (
                <RmaListBulkDismissModal
                    isLoading={dismissModal.isLoading}
                    onCancel={dismissModal.onCancel}
                    onConfirm={dismissModal.onConfirm}
                />
            )}
        </>
    );
});

export default RmaListBulkActionNotice;
